// extracted by mini-css-extract-plugin
export default {"wrapper":"CallJoinContent__wrapper___Pkvfq","control":"CallJoinContent__control___xtgm8"};